export function buildConversationStatusBadge(t, meta) {
  const { status, assigneeId } = meta || {};
  if (!status) return null;

  if (status === 'resolved') {
    return {
      label: t('SEARCH.CONTACT_CONVERSATION_RESOLVED'),
      class:
        'bg-n-slate-4 text-n-slate-11 dark:bg-n-solid-3 dark:text-n-slate-10',
    };
  }

  if (status === 'pending') {
    return {
      label: t('SEARCH.CONTACT_CONVERSATION_PENDING'),
      class: 'bg-red-100 text-red-900 dark:bg-n-ruby-4 dark:text-n-ruby-12',
    };
  }

  if (status === 'open' && assigneeId) {
    return {
      label: t('SEARCH.CONTACT_CONVERSATION_IN_PROGRESS'),
      class:
        'bg-green-100 text-green-800 dark:bg-green-950/80 dark:text-green-300',
    };
  }

  return {
    label: t('SEARCH.CONTACT_CONVERSATION_OPEN'),
    class:
      'bg-n-amber-3 text-n-amber-12 dark:bg-n-amber-4 dark:text-n-amber-12',
  };
}

/** Conversation payload from API (snake_case or camelCase meta). */
export function resolveConversationStatusForBadge(conversation) {
  if (!conversation) return { status: null, assigneeId: null };

  const status = conversation.status;
  const meta = conversation.meta || {};
  const assigneeType = meta.assigneeType ?? meta.assignee_type;
  const assignee = meta.assignee || {};
  const rawId = assignee.id;
  let assigneeId = null;
  if (assigneeType !== 'AgentBot' && rawId != null) {
    assigneeId = Number(rawId);
  }

  return { status, assigneeId };
}

export function buildConversationStatusBadgeFromConversation(t, conversation) {
  return buildConversationStatusBadge(
    t,
    resolveConversationStatusForBadge(conversation)
  );
}
